// extracted by mini-css-extract-plugin
export default {"slider":"_slider_nIcL+g","hints":"_hints_DSVX3x"};